module.exports = __webpack_public_path__ + "img/img_list_14@2x.07311556.png";